export const FETCH_LEAVE_TYPES_REQUEST = "FETCH_LEAVE_TYPES_REQUEST";
export const FETCH_LEAVE_TYPES_SUCCESS = "FETCH_LEAVE_TYPES_SUCCESS";
export const FETCH_LEAVE_TYPES_FAIL = "FETCH_LEAVE_TYPES_FAIL";

export const FETCH_USER_LEAVE_TYPES_REQUEST = "FETCH_USER_LEAVE_TYPES_REQUEST";
export const FETCH_USER_LEAVE_TYPES_SUCCESS = "FETCH_USER_LEAVE_TYPES_SUCCESS";
export const FETCH_USER_LEAVE_TYPES_FAIL = "FETCH_USER_LEAVE_TYPES_FAIL";

export const CLEAR_USER_LEAVE_TYPES = "CLEAR_USER_LEAVE_TYPES";